import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RestService } from './lib/RestService';
import { setQueryParams } from './lib/helpers';
import { environment } from '../environments/environment';

export class SmartFilterItem {
  ID: number;
  NAME: string;
  CODE: string;
  VALUES: any;
  USER_TYPE?: string;
  IBLOCK_ID?: number;
  FILTER_HINT?: string;
  DISPLAY_TYPE?: string;
  PROPERTY_TYPE?: string;
  DISPLAY_EXPANDED?: string;
}

export class SmartFilter {
  ITEMS: SmartFilterItem[];
  COMBO: any[];
  PRICES: object;
  HIDDEN: any[];
  FILTER: object | any[];
  FORM_ACTION: string;
  FACET_FILTER: boolean;
  PROPERTY_COUNT: number;
  PROPERTY_ID_LIST: any[];
}

@Injectable()
export class CatalogFilterService extends RestService {

  private apiUrl = `${environment.apiUrl}shop/CatalogFilter/`;

  constructor(private http: HttpClient) {
    super();
  }

  // public async get(sectionId: string): Promise<SmartFilter | any> {
  //   try {
  //     const apiUrl = `${this.apiUrl}?SECTION_ID=${sectionId}`;
  //     let filter = await this.http.get<SmartFilter>(apiUrl).toPromise();
  //     let arrayItems = [];
  //     for (let key in filter.ITEMS) {
  //       if (filter.ITEMS.hasOwnProperty(key)) {
  //         if (Array.isArray(filter.ITEMS[key].VALUES) && filter.ITEMS[key].VALUES.length === 0) continue;
  //
  //         if (filter.ITEMS[key].CODE !== 'PRICE')
  //           filter.ITEMS[key].VALUES = Object.values(filter.ITEMS[key].VALUES);
  //
  //         arrayItems.push(filter.ITEMS[key]);
  //       }
  //     }
  //     filter.ITEMS = arrayItems;
  //     return filter;
  //   } catch (e){
  //     this.handleError(e);
  //   }
  // }

  public async getItems(sectionId: string): Promise<SmartFilterItem[] | any> {
    try {
      const apiUrl = `${this.apiUrl}?SECTION_ID=${sectionId}`;
      const filter = await this.http.get<SmartFilter>(apiUrl).toPromise();
      const arrayItems = [];
      for (const key in filter.ITEMS) {
        if (filter.ITEMS.hasOwnProperty(key)) {
          if (Array.isArray(filter.ITEMS[key].VALUES) && filter.ITEMS[key].VALUES.length === 0) continue;

          if (filter.ITEMS[key].CODE !== 'PRICE') {
            filter.ITEMS[key].VALUES = Object.values(filter.ITEMS[key].VALUES);
          }

          arrayItems.push(filter.ITEMS[key]);
        }
      }
      return arrayItems;
    } catch (e) {
      this.handleError(e);
    }
  }

  public async getFilter(sectionId: string, customFilters: object): Promise<object | any> {
    try {
      let apiUrl = `${this.apiUrl}?SECTION_ID=${sectionId}`;
      apiUrl = setQueryParams(apiUrl, customFilters);
      const res = await this.http.get<SmartFilter>(apiUrl).toPromise();
      return Array.isArray(res.FILTER) ? {} : res.FILTER;
    } catch (e) {
      this.handleError(e);
    }
  }
}
